import { useMutation } from '@tanstack/react-query';

import { $api, errorHandler } from '../../global';

export const useDownloadCertificate = () =>
  useMutation({
    mutationFn: async (ticketId?: number) => {
      const res = await $api.post(`/certification?ticket_id=${ticketId}`);

      return res.data;
    },
    onSuccess: certificate => {
      window.open(certificate?.download_url, '_blank');
    },
    onError: errorHandler()
  });
